var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewDatabaseDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "view logs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Log-Details-Copy",
    transform: "translate(-1219.000000, -658.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "view-logs",
    transform: "translate(1219.000000, 658.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 4.000000)",
    fillRule: "nonzero",
    id: "Shape",
    stroke: "#959595"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.125,0 L1.625,0 C0.73125,0 0,0.72 0,1.6 L0,14.4 C0,15.28 0.723125,16 1.616875,16 L11.375,16 C12.26875,16 13,15.28 13,14.4 L13,4.8 L8.125,0 Z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09476563,6.902 C6.6959914,6.902 7.29832918,7.12773577 7.75794787,7.58028341 C8.12404649,7.94074974 8.33950992,8.38969002 8.40727077,8.85671867 C8.49456192,9.45835612 8.3378562,10.0890952 7.94794445,10.599382 L7.94794445,10.599382 L9.18660335,11.8188775 L7.51138392,11.0221356 C6.99318408,11.4075445 6.35542984,11.5592716 5.7467053,11.4736488 C5.26794595,11.4063069 4.80722141,11.1915756 4.43767713,10.8277166 C3.9812631,10.3783243 3.75203125,9.7914257 3.75203125,9.204 C3.75203125,8.6165743 3.9812631,8.02967568 4.43897975,7.57899612 C4.89459306,7.12709369 5.49447997,6.902 6.09476563,6.902 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDatabaseDisabled);
export default __webpack_public_path__ + "static/media/viewDatabaseDisabled.6edaf6b2005680ab2cbe796ba52cf0ca.svg";
export { ForwardRef as ReactComponent };